export const generateMessageList = (messageObj) => {
  let list = [];

  Object.keys(messageObj).forEach((key) => {
    list = [...list, messageObj[key][0]];
  });

  return list.sort((a, b) => a.order - b.order);
};

export const clearNullOrUndefined = (obj) => {
  const newObj = {};

  Object.keys(obj).forEach((key) => {
    if (obj[key]) newObj[key] = obj[key];
  });

  return newObj;
};

export const initialSearchData = {
  start: "",
  end: "",
  agent: null,
  number: "",
  queue_id: null,
};
